import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-accent)";

function IconAIOrganize({
    class: cssClass,
    color,
    secondaryColor
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const stroke = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M3.5 8a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5zm9.575 1c.51 0 .923.448.923 1v3c0 .552-.413 1-.923 1H6.923C6.413 14 6 13.552 6 13v-3c0-.552.413-1 .923-1h6.152zm-6.152 4h6.152v-3H6.923v3zm1.36-10.959A2.1 2.1 0 0 0 7.243 3h-4.32v3h5.455l1.144.507.212.493H2.923C2.413 7 2 6.552 2 6V3c0-.552.413-1 .923-1h5.454l-.094.041z"/>
            <path stroke={stroke} d="M11.418.882a.637.637 0 0 1 1.12-.09l.047.09.616 1.413.041.083a.979.979 0 0 0 .464.423l1.408.615.006.002.09.048a.637.637 0 0 1-.09 1.118h-.002l-1.412.617a.979.979 0 0 0-.464.422l-.04.083-.616 1.411h-.001a.636.636 0 0 1-1.168-.002L10.82 5.73a.98.98 0 0 0-.502-.508L8.88 4.586v-.001a.636.636 0 0 1 .003-1.166l1.413-.617a.98.98 0 0 0 .505-.506l.616-1.412.001-.001zM15.4 4.005zm-.423-.626zm.436.565v-.003a.517.517 0 0 1 0 .003z"/>
        </svg>

    );
}

export default IconAIOrganize;
